import type { InternalAxiosRequestConfig } from 'axios';
import { AUTH0_CLIENT_ID } from '../magic-values';

type TokenGetter = () => Promise<string>;

const AUTH_PROVIDER_HEADER = 'bagel-auth-provider';
const CLIENT_ID_HEADER = 'bagel-client-id';
const AUTH0_PROVIDER = 'auth0';

class AuthInterceptor {
  private getToken: TokenGetter | undefined;

  setAuthGetter(getToken: TokenGetter | undefined): void {
    this.getToken = getToken;
  }

  intercept = async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    if (this.getToken) {
      try {
        const token = await this.getToken();
        config.headers.Authorization = `Bearer ${token}`;
        config.headers[AUTH_PROVIDER_HEADER] = AUTH0_PROVIDER;
        config.headers[CLIENT_ID_HEADER] = AUTH0_CLIENT_ID;
      } catch (e) {
        console.error(e);
      }
    }
    return config;
  };
}

export const authInterceptor = new AuthInterceptor();
